import { fetchWithAuth } from "./FetchWithAuth";
import { url } from "./url";

const apiBase = `${String(url).replace(/\/+$/, "")}/api`;

async function request(path, options = {}, auth = true) {
  const endpoint = `${apiBase}${path}`;
  const fetcher = auth ? fetchWithAuth : fetch;
  const response = await fetcher(endpoint, {
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      ...(options.headers || {}),
    },
    ...options,
  });
  if (!response || !response.json) return {};
  return response.json();
}

export const eventAccessApi = {
  generateAccess: (eventId) =>
    request(`/events/${eventId}/generate-access`, { method: "POST" }),

  sendQr: (accessId) =>
    request(`/event-access/send/${accessId}`, { method: "POST" }),

  sendAllQr: (eventId) =>
    request(`/events/${eventId}/send-all-access`, { method: "POST" }),

  myCode: () =>
    request("/event-access/my-code"),

  scan: (token) =>
    request("/event-access/scan", {
      method: "POST",
      body: JSON.stringify({ token }),
    }),

  listEventAccess: (eventId, params = {}) => {
    const qs = new URLSearchParams(params).toString();
    return request(qs ? `/events/${eventId}/access?${qs}` : `/events/${eventId}/access`);
  },
};
